module.exports = __webpack_public_path__ + "images/markus_koch.jpg?v=3fbd2a7ee31a9343aad5533607faa413";